import { object, ObjectSchema, string } from 'yup';

import { CurrencyValue } from '@client/api';

const schema: ObjectSchema<CurrencyValue> = object({
  code: string().required(),
  symbol: string(),
  englishName: string()
});

export { schema as currencyValueSchema };
